import { View, Text, Carousel } from "reshaped";
import { WorkItem } from "./WorkItem";
import { useResponsiveClientValue } from "../../hooks";
import { WorksProps } from "./Works.types";

export const Works = (props: WorksProps) => {
  const { list } = props;

  const viewItem: any | undefined = useResponsiveClientValue({
    s: 1,
    m: 2,
    l: 3,
  });
  return (
    <View gap={10}>
      <Text variant="featured-1" weight="bold">
        Mis Trabajos
      </Text>

      <Carousel visibleItems={viewItem}>
        {list
          ?.filter((item) => item.mine)
          .map((item) => (
            <WorkItem key={item.id} list={item} />
          ))}
      </Carousel>

      <Text variant="featured-1" weight="bold">
        Trabajos en los que participe
      </Text>

      <Carousel visibleItems={viewItem}>
        {list
          ?.filter((item) => !item.mine)
          .map((item) => (
            <WorkItem key={item.id} list={item} />
          ))}
      </Carousel>
    </View>
  );
};
